import React from 'react';
import Logo2Image from '../assets/images/2.png';
import LogoImage from '../assets/images/logo-2.png';

const Logo = () => <img src={Logo2Image} height="128" width="100%" />
const Logo2 = () => <img src={LogoImage} height="43" width="100%" />

export { Logo, Logo2 };
